// src/components/UndeleteUsers.js
import React, { Component } from "react";
import { ReactTabulator } from "react-tabulator";
import { getDeletedUsersByClientId, restoreUsers } from "../../libs/API";
import "react-tabulator/lib/css/tabulator.min.css";
import { Button } from "react-bootstrap";
import { RestoreUserSvg } from "../Svg/allsvg"; // adjust path as needed

class UndeleteUsers extends Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.state = {
      users: [],
      loading: false,
      error: null,
    };
  }

  async componentDidMount() {
    if (this.props.clientId) {
      await this.loadDeletedUsers();
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.clientId !== this.props.clientId && this.props.clientId) {
      await this.loadDeletedUsers();
    }
  }

  loadDeletedUsers = async () => {
    const { clientId } = this.props;
    if (!clientId) {
      this.setState({ users: [], loading: false });
      return;
    }

    this.setState({ loading: true, error: null });
    try {
      const users = await getDeletedUsersByClientId(clientId);
      this.setState({ users });

      // only clear selection if the table has been mounted
      if (this.tableRef.current && this.tableRef.current.table) {
        this.tableRef.current.table.deselectRow();
      }
    } catch (err) {
      if (err.response?.status === 404) {
        this.setState({ users: [] });
      } else {
        console.error(err);
        this.setState({ error: "Failed to load deleted users." });
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  handleRestore = async () => {
    const table = this.tableRef.current?.table;
    if (!table) return;

    const selected = table.getSelectedData();
    if (!selected.length) {
      alert("Please select at least one user to restore.");
      return;
    }
    if (!window.confirm(`Restore ${selected.length} user(s)?`)) return;

    try {
      const payload = selected.map((u) => ({
        userId: u.userId,
        email: u.email,
      }));
      await restoreUsers(payload);
      await this.loadDeletedUsers();
    } catch (err) {
      console.error(err);
      alert("Error restoring users. See console for details.");
    }
  };

  render() {
    const { users, loading, error } = this.state;

    if (loading) return <p>Loading deleted users…</p>;
    if (error) return <p className="text-danger">{error}</p>;
    if (!users.length)
      return <p>No deleted users found for client.</p>;

    const columns = [
      {
        formatter: "rowSelection",
        titleFormatter: "rowSelection",
        titleFormatterParams: { rowRange: "visible" },
        width: 20,
        headerSort: false,
        cellClick: (e, cell) => cell.getRow().toggleSelect(),
      },
      { title: "User ID", field: "userId" },
      { title: "Email", field: "email", headerFilter: "input" },
    ];

    return (
      <div>
        <Button
          bsClass="btn btn-outline-secondary"
          onClick={this.handleRestore}
          style={{ marginBottom: "0.75rem" }}
          title="Restore selected users"
        >
          <RestoreUserSvg style={{ marginRight: 4 }} />
        </Button>

        <ReactTabulator
          ref={this.tableRef}
          data={users}
          columns={columns}
          options={{
            selectable: true,
            layout: "fitData",
            pagination: "local",
            paginationSize: 10,
            placeholder: "No data available",
          }}
        />
      </div>
    );
  }
}

export default UndeleteUsers;
